import { Component, inject, computed } from '@angular/core';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from 'htx-ui-library';
import { AsyncPipe } from '@angular/common';
import { AuthService } from '../../../services/auth/auth.service';
import { RoleService } from '../../../services/role/role.service';
import { UserRole } from '../../../services/auth/auth.role';
import { toSignal } from '@angular/core/rxjs-interop';

export interface QuickLink {
  labelKey: string;
  icon: string;
  route: string[];
}

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  imports: [
    TranslocoDirective,
    ButtonComponent,
    TranslocoPipe,
    ReactiveFormsModule,
    RouterLink,
    AsyncPipe
  ],
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private roleService = inject(RoleService);

  isLoggedIn$ = this.authService.isLoggedIn$;

  private userRoles = toSignal(this.roleService.getUserRoles$(), { initialValue: [] as string[] });

  quickLinks = computed<QuickLink[]>(() => {
    const roles = this.userRoles();

    if (roles.includes(UserRole.DataspaceAuthority)) {
      return [
        { labelKey: 'home.quickLinks.profile', icon: 'person', route: ['/profile'] },
        { labelKey: 'home.quickLinks.dashboard', icon: 'dashboard', route: ['/admin/dashboard'] },
        { labelKey: 'home.quickLinks.requests', icon: 'assignment', route: ['/admin/requests'] },
        {
          labelKey: 'home.quickLinks.organizations',
          icon: 'business',
          route: ['/admin/organizations']
        }
      ];
    }

    if (
      roles.includes(UserRole.OrganizationAdmin) ||
      roles.includes(UserRole.OrganizationRepresentative)
    ) {
      return [
        { labelKey: 'home.quickLinks.profile', icon: 'person', route: ['/profile'] },
        {
          labelKey: 'home.quickLinks.organisation',
          icon: 'business',
          route: ['/admin/organizations']
        },
        { labelKey: 'home.quickLinks.appManagement', icon: 'apps', route: ['/app-management'] }
      ];
    }

    if (roles.includes(UserRole.OrganizationUser)) {
      return [{ labelKey: 'home.quickLinks.profile', icon: 'person', route: ['/profile'] }];
    }

    return [];
  });

  /**
   * t(home.registerButton)
   */
  registerButtonKey = 'home.registerButton';

  goToRegister() {
    void this.router.navigate(['registration'], { relativeTo: this.activatedRoute });
  }

  navigateTo(route: string[]) {
    void this.router.navigate(route);
  }
}
